import React, {useState, useEffect} from 'react';
import {useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";

const EmployeeShowComponent = (props) => {

  const {t} = props;
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [identitydocumentTypes, setIdentitydocumentTypes] = useState([]);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const identityDocMap = (identitydocumentTypes || []).reduce((acc, item) => {
    acc[item.key] = item.value;
    return acc;
  }, {});

  useEffect(() => {
    if (id) {
      setLoading(true);
      apiCall('get', '/api/v2/employee/' + id)
        .then(response => {
          setFormData(response.data.data)
          if (typeof props.onLoaded === 'function') {
            props.onLoaded(response.data.data);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [id, window.App.state.rerenderEmployeeList, window.App.state.rerenderEmployeeShow])

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/identity-document-type')
      .then(response => {
        setIdentitydocumentTypes(response.data.data);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  return (
    <div className={"employee-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="last_name">{t('columnLastName')}</label>
            <span className="p-d-block fake-input">
              {formData.last_name}
            </span>
          </div>
        </div>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="first_name">{t('columnFirstName')}</label>
            <span className="p-d-block fake-input">
              {formData.first_name}
            </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        <div className={"p-col-12 p-lg-6"}>
          <div className="p-field p-fluid">
            <label htmlFor="employee_position_name">{t('columnPosition')}</label>
            <span className="p-d-block fake-input">
              {formData.employee_position?.name}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label htmlFor="email">{t('columnEmail')}</label>
            <span className="p-d-block fake-input">
              {formData.email}
            </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label htmlFor="insurance_number">{t('fieldInsuranceNumber')}</label>
            <span className="p-d-block fake-input">
              {formData.insurance_number}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-6">
          <div className="p-field p-fluid">
            <label htmlFor="tax_number">{t('columnTaxNumber')}</label>
            <span className="p-d-block fake-input">
              {formData.tax_number}
            </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        <div className="p-col-12 p-lg-4">
          <div className="p-field p-fluid">
            <label htmlFor="identity_document_type">{t('fieldIdentityDocumentType')}</label>
            <span className="p-d-block fake-input">
              {identityDocMap[formData.identity_document_type]}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-4">
          <div className="p-field p-fluid">
            <label htmlFor="identity_document_number">{t('fieldIdentityDocumentNumber')}</label>
            <span className="p-d-block fake-input">
              {formData.identity_document_number}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-4">
          <div className="p-field p-fluid">
            <label htmlFor="identity_document_valid_until">{t('fieldIdentityDocumentValidUntil')}</label>
            <span className="p-d-block fake-input">
              {formData.identity_document_valid_until &&
              <>
                {window.App.formatDateValue(formData.identity_document_valid_until)}
              </>
              }
            </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        <div className="p-col-12 p-lg-12">
          <div className="p-field p-fluid">
            <label htmlFor="phone_country_code">{t('columnPhone')}</label>
            <span className="p-d-block fake-input">
              +{formData.phone_country_code} {formData.phone_area_code} {formData.phone_number} {formData.phone_suffix}
            </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        <div className="p-col-12 p-lg-4">
          <div className="p-field p-fluid">
            <label>{t('employeeRecords.motherName')}</label>
            <div>{formData.mother_name || '—'}</div>
            <label htmlFor="birth_place">{t('fieldBirthPlace')}</label>
            <span className="p-d-block fake-input">
              {formData.birth_place}
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-4">
          <div className="p-field p-fluid">
            <label htmlFor="birth_day">{t('columnDateOfBirth')}</label>
            <span className="p-d-block fake-input">
              {formData.birth_day &&
                <>
                  {window.App.formatDateValue(formData.birth_day)}
                </>
              }
            </span>
          </div>
        </div>
        <div className="p-col-12 p-lg-4">
          <div className="p-field p-fluid">
            <label htmlFor="citizenship">{t('fieldCitizenship')}</label>
            <span className="p-d-block fake-input">
              {formData?.citizenship?.name}
            </span>
          </div>
        </div>
      </div>
      <div className={"p-grid p-mt-1"}>
        {formData.bank_account &&
          <div className="p-col-12 p-lg-12">
            <div className="p-field p-fluid">
              <label htmlFor="bank_account">{t('fieldBankAccount')}</label>
              <span className="p-d-block fake-input">
                {formData.bank_account}
              </span>
            </div>
          </div>
        }
        <div className="p-col-12 p-lg-12">
          <div className="p-field p-fluid">
            <label htmlFor="note">{t('columnComment')}</label>
            <span className="p-d-block fake-input">
              {formData.note}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
export default withTranslation('common')(EmployeeShowComponent);
